import { es } from 'date-fns/locale';
import { getYear, format, set, isValid, parse, differenceInYears, formatDistance } from 'date-fns';
import { capitalize, orderBy } from 'lodash';

const FORMAT = 'dd-MM-yyyy';

export const locale = es;
export const DAYS = [
  '1',
  '2',
  '3',
  '4',
  '5',
  '6',
  '7',
  '8',
  '9',
  '10',
  '11',
  '12',
  '13',
  '14',
  '15',
  '16',
  '17',
  '18',
  '19',
  '20',
  '21',
  '22',
  '23',
  '24',
  '25',
  '26',
  '27',
  '28',
  '29',
  '30',
  '31'
];

export const YEARS = (order, _locale = 'es', addYears = 0) => {
  const yearStart = 1944;
  const intervalYear = getYear(new Date()) - yearStart + addYears;
  const years = Array.from({ length: intervalYear + 1 }, (item, i) => {
    const _year = new Date(yearStart + i, 1, 0).toLocaleString(_locale, { year: 'numeric' });
    return { label: _year, value: _year };
  });
  return orderBy(years, 'label', order);
};

/**
 * return array = {label,value}
 */
export const MONTHS = Array.from({ length: 12 }, (item, i) => {
  const date = new Date(0, i, 1);
  const monthL = format(date, 'MMMM', { locale });
  const month = i;
  return { label: capitalize(monthL), value: month };
});

export const validateDate = (date) => {
  const parsedDate = parse(date, FORMAT, new Date(), { locale });
  const isValidDate = isValid(parsedDate);
  return isValidDate;
};

export const parseDate = (date) => {
  const result = parse(date, FORMAT, new Date());
  if (isValid(result)) return result;
  return null;
};

export const isCurrentDate = (date) => {
  const result = parse(date, FORMAT, new Date());
  const current = new Date();
  if (isValid(result)) {
    if (result.getFullYear() === current.getFullYear() && result.getMonth() === current.getMonth()) {
      return true;
    }
  }
  return false;
};
/**
 *
 * @param {number} year
 * @param {number} month
 * @param {number} day
 * @returns
 */
export const formatDateObject = ({ year, month, day }) => {
  const _d = set(new Date(), { year, month, date: day });
  const formattedDate = format(_d, FORMAT);
  return formattedDate;
};

/**
 * date in object
 * @param {number} year
 * @param {number} month
 * @param {number} day
 * @returns
 */
export const isOlderYears = ({ year, month, day }, maxYears = 18) => {
  const years = differenceInYears(new Date(), new Date(year, month, day));
  return years >= maxYears;
};

export const formatDistanceDate = (date) => {
  if (date.getMonth() === new Date().getMonth() && date.getFullYear() === new Date().getFullYear()) {
    return formatDistance(date, new Date(), { includeSeconds: false, locale });
  }
  return format(date, FORMAT, { locale });
};
